import { hashMessage, hashTypedData, } from "viem";
import { MultiOwnerPlugin, MultiOwnerPluginAbi } from "./plugin.js";
export const multiOwnerMessageSigner = (client, accountAddress, signer, pluginAddress = MultiOwnerPlugin.meta.addresses[client.chain.id]) => {
    const signWith712Wrapper = async (msg) => {
        const [, name, version, chainId, verifyingContract, salt] = await client.readContract({
            abi: MultiOwnerPluginAbi,
            address: pluginAddress,
            functionName: "eip712Domain",
            account: accountAddress,
        });
        return signer().signTypedData({
            domain: {
                chainId: Number(chainId),
                name,
                salt,
                verifyingContract,
                version,
            },
            types: {
                AlchemyModularAccountMessage: [{ name: "message", type: "bytes" }],
            },
            message: {
                message: msg,
            },
            primaryType: "AlchemyModularAccountMessage",
        });
    };
    return {
        getDummySignature: () => {
            return "0xfffffffffffffffffffffffffffffff0000000000000000000000000000000007aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa1c";
        },
        signUserOperationHash: (uoHash) => {
            return signer().signMessage({ raw: uoHash });
        },
        signMessage({ message, }) {
            return signWith712Wrapper(hashMessage(message));
        },
        signTypedData: (typedDataDefinition) => {
            return signWith712Wrapper(hashTypedData(typedDataDefinition));
        },
    };
};
//# sourceMappingURL=signer.js.map